import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './sidebar.scss';
import AuthService from "../../services/auth.service";
import APIConfig from "../../api/APIConfig";

import {
    VStack,
    HStack,
    Text,
} from '@chakra-ui/react';


const currentUser = AuthService.getCurrentUser();
let idMitra;
if (currentUser != undefined) {
    if (currentUser.mitra != null) {
        currentUser.mitra.map((data) => idMitra=data.idMitra)
        console.log(idMitra)
    }
}
const sidebarNavItems = [
    {
        display: 'Profil',
        icon: <i className='bx bx-user'></i>,
        to: `/mitra/profile/lihat/${idMitra}`,
        section: 'lihat'
    },
    {
        display: 'Proposal',
        icon: <i className='bx bx-folder'></i>,
        to: '/mitra/profile/proposal',
        section: 'proposal'
    },
    {
        display: 'Manajemen Mentor',
        icon: <i className='bx bx-group'></i>,
        to: `/mitra/profile/mentor/list-mentor/${idMitra}`,
        section: 'mentor'
    },
    {
        display: 'Partisipan Aktif',
        icon: <i className='bx bx-user-check'></i>,
        to: `/mitra/profile/PartisipanAktif/${idMitra}`,
        section: 'PartisipanAktif'
    },
    {
        display: 'Ganti Sandi',
        icon: <i className='bx bx-key'></i>,
        to: '/mitra/profile/change-password',
        section: 'change-password'
    },
    {
        display: 'Kembali',
        icon: <i className='bx bx-home'></i>,
        to: '/',
        section: 'home'
    },
]

const SidebarMitra = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [stepHeight, setStepHeight] = useState(0);
    const sidebarRef = useRef();
    const indicatorRef = useRef();
    const location = useLocation();
    const [currentUser, setCurrentUser] = useState([]);
    const [image, setImage] = useState(undefined);

    const defaultFoto = 'https://w7.pngwing.com/pngs/81/570/png-transparent-profile-logo-computer-icons-user-user-blue-heroes-logo-thumbnail.png'

    useEffect(() => {
        const user = AuthService.getCurrentUser();
    
        if (user) {
            setCurrentUser(user);
        }

        getImage();
    }, [])

    useEffect(() => {
        setTimeout(() => {
            const sidebarItem = sidebarRef.current.querySelector('.sidebar__menu__item');
            indicatorRef.current.style.height = `${sidebarItem.clientHeight}px`;
            setStepHeight(sidebarItem.clientHeight);
        }, 50);
    });

    useEffect(() => {
        const curPath = window.location.pathname.split('/')[3];
        const activeItem = sidebarNavItems.findIndex(item => item.section === curPath);
        setActiveIndex(curPath.length === 0 ? 0 : activeItem);
    }, [location]);

    const getImage = async() => {
        const user = AuthService.getCurrentUser();
        const response = await APIConfig.get(`/v1/mitra/${user.mitra[0].idMitra}`);
        const data = await response.data
        
        if (data.image!=null) {
            setImage(data.image);
        } else {
            setImage(defaultFoto);
        }
    };

    return (
        <div>
            <div className='sidebar'>
                <div className="sidebar__logo">
                    Dashboard 
                </div>
                {currentUser.mitra && currentUser.mitra.map((data) =>
                <HStack pb={8}>
                    <div
                        style={{
                            display: 'inline-block',
                            position: 'relative',
                            overflow: 'hidden',
                            borderRadius: '50%', 
                            marginLeft: '2rem',
                            marginTop: '-1rem',
                            width: '50px', 
                            height: '50px',
                            }}
                    >
                        <img style={{
                            width: 'auto', 
                            height: '100%',
                            }} 
                        
                            className="preview" 
                            src={image} 
                            alt="avatar" />
                    </div>
                    <VStack align='stretch'>
                        <span style={{fontSize: '18px', fontWeight: '700'}}>{data.namaResmi}</span>
                        <span style={{fontSize: '12px', fontWeight: '400'}}>{currentUser.emailUser}</span>
                    </VStack>
                </HStack>)}
                <Text style={{fontSize: '14px', fontWeight: '700'}} pl={6} pt={4} pb={6}> Halaman Akun </Text>
                <div ref={sidebarRef} className="sidebar__menu">
                    <div
                        ref={indicatorRef}
                        className="sidebar__menu__indicator"
                        style={{
                            transform: `translateX(-50%) translateY(${activeIndex * stepHeight}px)`
                        }}
                    ></div>
                    {
                        sidebarNavItems.map((item, index) => (
                            <Link to={item.to} key={index}>
                                <div className={`sidebar__menu__item ${activeIndex === index ? 'active' : ''}`}>
                                    <div className="sidebar__menu__item__icon">
                                        {item.icon}
                                    </div>
                                    <div className="sidebar__menu__item__text">
                                        {item.display}
                                    </div>
                                </div>
                            </Link>
                        ))
                    }
                </div>
            </div> 

            <div className='mini__sidebar'>
                <div className="mini__sidebar__logo"></div>
                {currentUser.peserta && currentUser.peserta.map((data) =>
                <HStack pb={8}>
                    <div
                        style={{
                            display: 'inline-block',
                            position: 'relative',
                            overflow: 'hidden',
                            borderRadius: '50%', 
                            marginLeft: '0rem',
                            marginTop: '-1rem',
                            width: '50px', 
                            height: '50px',
                            }}
                    >
                        <img style={{
                            width: 'auto', 
                            height: '130%',
                            marginTop: '-5px',
                            }} 
                        
                            className="preview" 
                            src={image} 
                            alt="avatar" />
                    </div>
                </HStack>)}
                <div ref={sidebarRef} className="mini__sidebar__menu">
                    <div
                        ref={indicatorRef}
                        className="mini__sidebar__menu__indicator"
                        style={{
                            transform: `translateX(-50%) translateY(${activeIndex * stepHeight}px)`
                        }}
                    ></div>
                    {
                        sidebarNavItems.map((item, index) => (
                            <Link to={item.to} key={index}>
                                <div className={`mini__sidebar__menu__item ${activeIndex === index ? 'active' : ''}`}>
                                    <div className="mini__sidebar__menu__item__icon">
                                        {item.icon}
                                    </div>
                                </div>
                            </Link>
                        ))
                    }
                </div>
            </div>
        </div>
    );
};

export default SidebarMitra;